import script from "./GastoCartaoFormView.vue?vue&type=script&setup=true&lang=js"
export * from "./GastoCartaoFormView.vue?vue&type=script&setup=true&lang=js"

import "./GastoCartaoFormView.vue?vue&type=style&index=0&id=66b634d8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-66b634d8"]])

export default __exports__